import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import RequiredInput from '../../../../common/form/elements/required-input';

class GameLevelFormColumn extends Component {
  render() {
    const { level, hasNoLevels } = this.props;
    const numberOfOutersModel = `game_levels.level-${level}.minimum-number-of-outers`;
    const prizeAmountsModel = `game_levels.level-${level}.prize-amount`;
    const gameNameModel = `game_levels.level-${level}.game-name`;

    return (
      <Col md={3}>
        <Row>
          <Col md={12}>
            <b>Game level {level}</b>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <RequiredInput
              label="Min. Number of Outers"
              model={`.${numberOfOutersModel}.value`}
              type="number"
              min={0}
              step="any"
              disabled={hasNoLevels}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <RequiredInput
              label="Prize amount"
              model={`.${prizeAmountsModel}.value`}
              type="number"
              min={0}
              step="any"
              disabled={hasNoLevels}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <RequiredInput
              label="Game Name"
              model={`.${gameNameModel}.value`}
              type="text"
              disabled={hasNoLevels}
            />
          </Col>
        </Row>
      </Col>
    );
  }
}

export default GameLevelFormColumn;



// WEBPACK FOOTER //
// ./src/components/admin/games/game-levels/form/game-level-form-column.jsx